import './RecentSearchResults.scss';

import { AccessTypeTag } from './AccessTypeTag';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { createAsyncSelectors } from '@lib/selectors';
import EmptyDetectedApps from 'images/empty-search-state.svg';
import { HistoryOutlined } from '@ant-design/icons';
import { MenuInfo } from 'rc-menu/es/interface';
import { NoData } from '@ui/NoData';
import { SonarText } from '@ui/text';

import { AccessType, coreActions } from '@sonar-software/sonar-core';
import { Menu, Space } from 'antd';
import React, { useCallback, useMemo } from 'react';
import { useAction, useAsyncState, useOnMount } from '@hooks';

type SearchOption = { label: string; type: AccessType; value: string; };

export interface RecentSearchResultsProps {
	onSelect: (option: SearchOption) => void;
}

const selectors = createAsyncSelectors((state) => state.core.dataSecurity.dataAccess.search.history.get);

export const RecentSearchResults: React.FC<RecentSearchResultsProps> = ({ onSelect }) => {
	const { data, isRequested } = useAsyncState(selectors);

	const load = useAction(coreActions.requestGetCoreDataSecurityDataAccessSearchHistory);

	useOnMount(() => {
		load({});
	});

	const items = useMemo(() => (data ?? []).map((entry) => ({
		icon: <HistoryOutlined />,
		key: entry.targetId,
		label: <Space>{ entry.targetDisplay }<AccessTypeTag accessType={ entry.targetType } /></Space>
	})), [ data ]);

	const handleSelect = useCallback((info: MenuInfo) => {
		const entry = data?.find((item) => item.targetId === info.key);

		if (entry) {
			onSelect({
				label: entry.targetDisplay,
				type: entry.targetType as AccessType,
				value: entry.targetId
			});
		}
	}, [ data, onSelect ]);

	if (isRequested) {
		return null;
	}

	const isEmpty = !data?.length;

	return (
		<div className='recent-search-wrapper'>
			<SonarText
				className='recent-search-header'
				size={ 20 }
				weight='semibold'>
				{ COPY_SPECIFIC.RECENT_SEARCHES }
			</SonarText>
			{ isEmpty ?
				<NoData
					className='left-aligned-no-data'
					description={ COPY_SPECIFIC.RECENT_SEARCHES_DESCRIPTION }
					image={ EmptyDetectedApps }
					styles={ {
						description: {
							color: 'black',
							textAlign: 'left'
						}
					} } /> :
				<Menu
					className='recent-search-item-menu'
					items={ items }
					mode='inline'
					onSelect={ handleSelect } /> }

		</div>
	);
};
